const OverViewIcon = (props: any) => {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.8">
          <path
            d="M18 15.75H19.5V19.5H18V15.75ZM15 12H16.5V19.5H15V12ZM8.25 19.5C7.2558 19.4988 6.30267 19.1033 5.59966 18.4003C4.89666 17.6973 4.50119 16.7442 4.5 15.75H6C6 16.195 6.13196 16.63 6.37919 17C6.62643 17.37 6.97783 17.6584 7.38896 17.8287C7.8001 17.999 8.2525 18.0436 8.68895 17.9568C9.12541 17.87 9.52632 17.6557 9.84099 17.341C10.1557 17.0263 10.37 16.6254 10.4568 16.189C10.5436 15.7525 10.499 15.3001 10.3287 14.889C10.1584 14.4778 9.87004 14.1264 9.50003 13.8792C9.13002 13.632 8.69501 13.5 8.25 13.5V12C9.24456 12 10.1984 12.3951 10.9017 13.0983C11.6049 13.8016 12 14.7554 12 15.75C12 16.7446 11.6049 17.6984 10.9017 18.4017C10.1984 19.1049 9.24456 19.5 8.25 19.5Z"
            fill={props?.color ?? "black"}
          />
          <path
            d="M21 3L3 3.24471C3.07657 3.24366 2.87891 3.24471 2.5 3.5C2.153 3.73379 2 4 2 4.5L2.00005 9.24471V13.54V22.7447C2.00005 23.1425 2.00005 23.7447 2.00005 23.2447C2.00005 23.7447 2.60222 23.7447 3.00005 23.7447H21C21.3977 23.7441 21.5 23.7447 22 23.7447C22 23.2447 21.9995 22.7806 22 22.383V13.2447V4.5C22 4.10218 22 3.74471 22 3.74471C22 3.24471 21.3979 3 21 3ZM21 10H10L10 7V4.5H21V10ZM9.00005 4.5V10H3.00005V4.5H9.00005ZM3.00005 22.5V10.6995L12 10.7447H21L21.0015 22.5H3.00005Z"
            fill={props?.color ?? "black"}
          />
        </g>
      </svg>
    </div>
  );
};

export default OverViewIcon;
